import { IGetWorkerTasksResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export interface IGetWorkerTasksOptions {
  employeeIDs: string[];
  companyID: string;
}

export const getWorkerTasksStatus = (axios: IAxiosInstance) => {
  return async (options: IGetWorkerTasksOptions) => {
    const { employeeIDs, companyID } = options;
    const response = await axios.noRetry.post<
      IApiResponse<IGetWorkerTasksResponse[]>
    >(`/company/${companyID}/employees/tasks/status`, {
      employeeIDs,
    });
    return response.data;
  };
};
